











import { Vue, Component, Model } from 'vue-property-decorator';
import { clearStorage } from '@/utils/storage';

// 应用更新检测提示框
@Component
export default class AppUpdateToast extends Vue {
  @Model('visibleChange') public modelVisible!: boolean;

  public get visible() {
    return this.modelVisible || false;
  }

  public set visible(visible: boolean) {
    this.$emit('visibleChange', visible);
  }

  public onRefresh() {
    clearStorage();
    window.location.reload();
    this.visible = false;
  }
}
